import { render } from "./HeroiconsOutlineTranslate.vue?vue&type=template&id=06731bfc"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTranslate.vue"]])

export default __exports__